import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import moment, { Moment } from 'moment';

import { Basket } from '../../Modules/Basket';
import {
  ApiUserType,
  PaymentMethod,
  ReceivingMethod,
} from '../../api/def_common_api';
import { getStoreLocal } from '../../utils/local-storage';
import { formatPhoneNumber } from '../../utils/string/formatPhone';

import { BasketPageState } from './basket.interface';

const minDate = new Date();

const user = getStoreLocal('profile');
const cityValue = getStoreLocal('city_value');
const initialState: BasketPageState = {
  items: [],
  order_quantity: 0,
  order_sum: 0,
  cards_id: [],
  // Добавить адрес доставки
  addressValue: {
    address: '',
    fullName: '',
    phone: '',
    comment: '',
  },
  modalAddressValue: {},
  orgValue: getStoreLocal('org_value'),
  activeDelivery: 'г. Владивосток',
  order_info: {},
  visibleBasketDialog: false,
  whereDeliveryTab: true,
  visibleBasketCodeDialog: false,
  visibleBasketLoginDialog: false,
  paymentMethod: PaymentMethod.PaymentOnline,
  addInModalAddressValue: false,
  otherRecipientValue: { fullName: '', phone: '' },
  checkBasketId: '',
  otherValue: cityValue,
  modalVisible: false,
  checkout: {
    orgName: user?.org_name,
    checkout_phone: formatPhoneNumber(user?.phone),
    checkout_email: user?.email,
    userType: ApiUserType.physical_person,
    delivery_address: '',
    delivery_date: minDate.toISOString(),
    delivery_courier_comment: '',
    other_recipient: false,
    other_recipient_name: '',
    other_recipient_phone: '',
    receiving_method: ReceivingMethod.SelfDelivery,
    payment_method: PaymentMethod.PaymentOnline,
    is_physical_person: true,
    delivery_sum_kopecks: 0,
    order_sum_kopecks: 0,
  },
};
export const basketSlice = createSlice({
  name: 'basket',
  initialState,
  reducers: {
    setBasketCatalogItems: (state, action) => {
      state.items = action.payload;
      state.order_quantity += 1;
    },
    setOrderQuantity: (state, action: PayloadAction<number>) => {
      state.order_quantity = action.payload;
    },
    setOrderSum: (state, action: PayloadAction<number>) => {
      state.order_sum = action.payload;
    },
    setAddCardsId: (state, action) => {
      state.cards_id = action.payload;
    },
    setAddAddressValue: (state, action) => {
      state.addressValue = action.payload;
      state.addInModalAddressValue = true;
    },
    setAddModalAddressValue: (state, action) => {
      state.modalAddressValue = action.payload;
    },
    setAddOrganization: (state, action) => {
      state.orgValue = action.payload;
    },
    setCheckoutValues: (state, action) => {
      state.checkout = action.payload;
    },
    setActiveDelivery: (state, action) => {
      state.activeDelivery = action.payload;
    },

    setAddOrderInfo: (state, action) => {
      state.order_info = action.payload;
    },
    setVisibleBasketDialog: (state, action) => {
      state.visibleBasketDialog = action.payload;
    },
    setBasketCodeVisible: (state, action) => {
      state.visibleBasketCodeDialog = action.payload;
    },
    setBasketLoginVisible: (state, action) => {
      state.visibleBasketLoginDialog = action.payload;
    },
    setWhereDeliveryVisibleTab: (state, action) => {
      state.whereDeliveryTab = action.payload;
    },
    getItems: (state) => {
      state.items = Basket.getFromLocalStorage();
    },
    setAddPaymentMethod: (state, action: PayloadAction<PaymentMethod>) => {
      state.paymentMethod = action.payload;
    },
    setOtherRecipientValue: (state, action) => {
      state.otherRecipientValue = action.payload;
    },
    setCheckBasketId: (state, action) => {
      state.checkBasketId = action.payload;
    },
    setHandleModal: (state, { payload }: PayloadAction<boolean>) => {
      state.modalVisible = payload;
    },
    setCityData: (state, { payload }) => {
      state.otherValue = payload;
    },
    setReceivingMethod: (state, { payload }) => {
      state.checkout.receiving_method = payload;
    },
    setIsPhysicalPerson: (state, { payload }) => {
      state.checkout.is_physical_person = payload;
    },
    /*    addItem: (state, action: PayloadAction<ICatalogItem>) => {
      if (
        state.items.filter((item) => item.item.id === action.payload.id)
          .length > 0
      ) {
        state.items = state.items.map((item) =>
          item.item.id === action.payload.id
            ? { item: item.item, count: item.count + 1 }
            : item
        );
      } else {
        state.items.push({ item: action.payload, count: 1 });
      }
      state.order_quantity += 1;
      saveToLocalStorage(state.items);
    },
    removeItem: (state, action: PayloadAction<number>) => {
      state.items = state.items
        .map((item) =>
          item.item.id === action.payload
            ? { ...item, count: item.count - 1 }
            : item
        )
        .filter((item) => item.count !== 0);
      state.order_quantity -= 1;
      saveToLocalStorage(state.items);
    },*/
  },
});
export const basketActions = basketSlice.actions;
export const { reducer } = basketSlice;
